import React, { useState } from 'react';
import PhotoViewer from './PhotoViewer';

// Full-width photo in its own shape; very tall photos are capped near 4:5 / 75vh and shown whole (contain).
export default function FeedPhoto({ src, alt = '', testId, style, onError }) {
  const [ratio, setRatio] = useState(null);
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  const boxRatio = ratio ? Math.max(ratio, 0.8) : 4 / 3;
  return (
    <>
      <button type="button" onClick={(e) => { e.stopPropagation(); setOpen(true); }} aria-label={alt ? `Open photo: ${alt}` : 'Open photo'} data-testid={testId}
        style={{ display: 'block', width: '100%', padding: 0, border: 'none', cursor: 'zoom-in', background: '#F3F4F6',
          aspectRatio: `${boxRatio}`, maxHeight: '75vh', overflow: 'hidden', ...style }}>
        <img src={src} alt={alt} loading="lazy" decoding="async"
          onLoad={(e) => { const { naturalWidth: w, naturalHeight: h } = e.currentTarget; if (w && h) setRatio(w / h); }}
          onError={() => { setFailed(true); onError?.(); }}
          style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain', opacity: ratio ? 1 : 0, transition: 'opacity 0.2s ease' }} />
      </button>
      {open && <PhotoViewer src={src} alt={alt} onClose={() => setOpen(false)} />}
    </>
  );
}
